<div class="modal-header bg-primary text-white">
  <h1>title</h1>
</div>
<div class="modal-body" ngbAutofocus>
  <p>content</p>
</div>
<div class="modal-footer">
  <button class="btn btn-primary" (click)="btnClose()">close</button>
</div>
